import React, {useEffect, useState} from 'react';
import {Layout} from '../components/common/Layout';
import TableContainer from '@mui/material/TableContainer';
import Paper from '@mui/material/Paper';
import classNames from './Packages.module.css';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import TableBody from '@mui/material/TableBody';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import {AddEditModal} from '../components/package/admin/AddEditModal';
import {useMutation, useQuery} from "@apollo/client";
import {GET_PACKAGES} from "../api/package/getPackages";
import {DELETE_PACKAGE} from "../api/package/deletePackage";
import {ErrorMessage} from "../components/common/ErrorMessage";

type Package = {
    code: string,
    description: string,
    id: string,
    updatedAt: Date,
    lastUpdatedBy: string,
    price: number,
    title: string,
}

export const Packages = () => {
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [selectedPackage, setSelectedPackage] = useState<undefined | Package>()
    const [isSnackBarOpen, setIsSnackBarOpen] = useState(false)
    const [packages, setPackages] = useState<Package[]>([])

    const {loading, data, refetch} = useQuery(GET_PACKAGES);

    const [deletePackage, {loading: isDeleteLoading, error}] = useMutation(DELETE_PACKAGE)

    const onDeletePackage = async (id: string) => {
        const {errors} = await deletePackage({variables: {deletePackageId: id}})

        if (errors === undefined || errors.length === 0) {
            refetch()
        } else {
            setIsSnackBarOpen(true)
        }
    }

    useEffect(() => {
        if (data !== undefined) {
            setPackages([...data.allPackages].sort(
                (a, b) => new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime()
            ))
        }
    }, [data])

    return (
        <Layout title="Packages" isLoading={loading || isDeleteLoading} showHeader showMenu>
            <Stack alignItems="flex-end" marginBottom="2rem">
                <Button variant="contained" color="success" onClick={() => setIsModalOpen(true)}>
                    Add New Package
                </Button>
            </Stack>

            <TableContainer component={Paper}>
                <Table className={classNames.table}>
                    <TableHead>
                        <TableRow>
                            <TableCell>Code</TableCell>
                            <TableCell>Title</TableCell>
                            <TableCell>Price</TableCell>
                            <TableCell>Last updated By</TableCell>
                            <TableCell>Last updated At</TableCell>
                            <TableCell>Actions</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {packages.map((row) => (
                            <TableRow key={row.code} className={classNames.row}>
                                <TableCell>{row.code}</TableCell>
                                <TableCell>{row.title}</TableCell>
                                <TableCell>{new Intl.NumberFormat('en-US', { style: 'currency', currency: 'SAR' }).format(row.price)}</TableCell>
                                <TableCell>{row.lastUpdatedBy}</TableCell>
                                <TableCell>{new Date(row.updatedAt).toUTCString()}</TableCell>
                                <TableCell>
                                    <Stack direction="row" gap="0.5rem">
                                        <Button size="small" variant="contained" color="info" onClick={() => {
                                            setIsModalOpen(true)
                                            setSelectedPackage(row)
                                        }}>
                                            Edit
                                        </Button>
                                        <Button
                                            color="error"
                                            size="small"
                                            variant="contained"
                                            onClick={() => onDeletePackage(row.id)}
                                        >
                                            Delete
                                        </Button>
                                    </Stack>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>

            {isModalOpen && (
                <AddEditModal
                    onClose={(shouldRefetch: boolean) => {
                        if (shouldRefetch) refetch()
                        setIsModalOpen(false)
                        setSelectedPackage(undefined)
                    }}
                    packageData={selectedPackage}
                />
            )}

            <ErrorMessage
                handleClose={() => setIsSnackBarOpen(false)}
                isOpen={isSnackBarOpen}
                message={error?.message}
            />
        </Layout>
    )
}
